import { Box, useMediaQuery } from '@mui/material';
import { FunctionComponent, ReactNode } from 'react';
import gaiaTheme from '../theme';

export const PageOuterContainer: FunctionComponent<{ children: ReactNode }> = ({ children }) => {
  const isMobileMode = useMediaQuery(gaiaTheme.breakpoints.down('sm'));
  return (
    <Box sx={{ pb: isMobileMode ? 3 : 6, pl: isMobileMode ? 3 : 6, pr: isMobileMode ? 3 : 6, pt: isMobileMode ? 3 : 5, mt: isMobileMode ? 5 : 0 }}>
      {children}
    </Box>
  )
}